import { App, Button, Flex, List, Modal, Table, Upload, UploadProps } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import {
    UploadOutlined,
    DownloadOutlined,
    CheckOutlined,
    CloseOutlined
  } from '@ant-design/icons';
import { FlieListInterface } from "../../model/IFileList";
import { RcFile } from "antd/es/upload";
import { useNavigate } from "react-router-dom";

export function UploadOtherDocument(){

    const { message,notification } = App.useApp();
    const navigate = useNavigate();

    
    const [FileAttachment, setFileAttachment] = useState([
        {   
            id:1,
            AttachmentType:'เค้าโครงวิจัย 3 บท',
            Status:'ยังไม่แนบ'
        },{
            id:2,
            AttachmentType:'เครื่องมือหรือแบบสอบถาม (ถ้ามี)',
            Status:'ยังไม่แนบ'
        },
        {
            id:3,
            AttachmentType:'หนังสือรับรองการประเมินคุณภาพเครื่องมือวิจัย(ถ้ามี)',
            Status:'ยังไม่แนบ'
        },
        {
            id:4,
            AttachmentType:'เอกสารแสดงความยินยอมเข้าร่วมโครงการวิจัยสำหรับอาสาสมัครทั่วไป (ถ้าเกี่ยวข้อง)',
            Status:'ยังไม่แนบ'
        },
        {
            id:5,
            AttachmentType:'เอกสารแสดงความยินยอมเข้าร่วมโครงการวิจัยสำหรับอาสาสมัครเด็ก 7-18 ปี (ถ้าเกี่ยวข้อง)',
            Status:'ยังไม่แนบ'
        },
        {
            id:6,
            AttachmentType:'เอกสารแสดงความยินยอมสำหรับอาสาสมัครกลุ่มเปราะบาง (ถ้าเกี่ยวข้อง)',
            Status:'ยังไม่แนบ'
        },
        {
            id:7,
            AttachmentType:'เอกสารรับรองการสอบผ่านโครงร่างวิทยานิพนธ์ ภาคนิพนธ์ หรือการศึกษาค้นคว้าอิสระ',
            Status:'ยังไม่แนบ'
        },
        {
            id:8,
            AttachmentType:'เอกสารสัญญาการให้ทุนวิจัย (ถ้ามี)',
            Status:'ยังไม่แนบ'
        },
        {
            id:9,
            AttachmentType:'หลักฐานการผ่านการอบรมจริยธรรมการวิจัยในมนุษย์',
            Status:'ยังไม่แนบ'
        },
        {
            id:10,
            AttachmentType:'หลักฐานการชำระเงินค่าธรรมเนียมในการพิจารณาจริยธรรมการวิจัยในมนุษย์',
            Status:'ยังไม่แนบ'
        },
        {
          id:11,
          AttachmentType:'หลักฐานการรับรองคำพิจารณาจริยธรรมจากที่ปรึกษา (สำหรับนักศึกษา)',
          Status:'ยังไม่แนบ'
        },
    ]);

    const [Topic,setTopic] = useState('')
    const [isActive,setisActive]= useState(false);
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    const [ShowFile,setShowFile] = useState(false);
    const [ShowImage,setShowImage] = useState(false);
    const [Part3Status,setPart3Status]= useState(true);
    const [ShowMultipleFiles,setShowMultipleFiles] = useState(false);
    const [SubFileList,setSubFileList] = useState<FlieListInterface[]>([])
    const [AllFileList,setAllFileList] = useState<FlieListInterface[]>([])
    const [FileType,setFileType] = useState<string | null>(null);
    const [ShowFileID, setShowFileID] = useState<number | undefined>(undefined);
    const [ShowDeletion,setShowDeletion] = useState(false);

    const [Part3OutlineStatus,setPart3OutlineStatus]= useState(true);
    const [Part3CourseStatus,setPart3CourseStatus]= useState(true);
    const [Part3RecieptStatus,setPart3RecieptStatus]= useState(true);


    const props: UploadProps = {
        name: 'file',
        action:  `${process.env.REACT_APP_BASE}/upload_pdf/${sessionStorage.getItem('Order_ID')}`,
        headers: {
          authorization: 'authorization-text',
        },
        async onChange(info) {
          if (info.file.status === 'done') {
            await axios
            .get(`${process.env.REACT_APP_BASE}/getFileList/${sessionStorage.getItem('Order_ID')}`)
            .then((res) => {
            if (res.status === 200 && res.data) {
                const uploadedFiles = res.data; // Array of { Topic: string }
        
                const updatedList = FileAttachment.map((item) => {
                const isUploaded = uploadedFiles.some(
                    (file: { Topic: string }) => file.Topic === item.AttachmentType
                );
                return {
                    ...item,
                    Status: isUploaded ? 'แนบแล้ว' : 'ยังไม่แนบ',
                };
                });
        
                setAllFileList(uploadedFiles);
                setFileAttachment(updatedList);
        
                const requiredTopics = [
                'เค้าโครงวิจัย 3 บท',
                'หลักฐานการผ่านการอบรมจริยธรรมการวิจัยในมนุษย์',
                'หลักฐานการชำระเงินค่าธรรมเนียมในการพิจารณาจริยธรรมการวิจัยในมนุษย์',
                ];
        
                const allRequiredUploaded = requiredTopics.every((requiredTopic) =>
                uploadedFiles.some((file: { Topic: string }) => file.Topic.trim() === requiredTopic)
                );
                if (allRequiredUploaded) {
                  console.log('part3')
                  setPart3Status(false)
              }
            }
            });
          } else if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
          }
        },
        
      };

      async function viewFile(Topic:any){
        setTopic(Topic)
        console.log(Topic);

        if (Topic === "เครื่องมือหรือแบบสอบถาม (ถ้ามี)"
        ||Topic === "เอกสารสัญญาการให้ทุนวิจัย (ถ้ามี)"
          ) {
              setisActive(true);
              const filtered = AllFileList.filter(item => item.Topic.trim() === Topic);
              setSubFileList(filtered);
              setShowMultipleFiles(true);
              setisActive(false);
          }else if(Topic=='หลักฐานการผ่านการอบรมจริยธรรมการวิจัยในมนุษย์'){
          
          const filtered = AllFileList.filter(item => item.Topic.trim() === Topic);
          console.log(filtered[0].FileType)
          if(filtered[0].FileType=='image/jpeg'||filtered[0].FileType=='image/png'){
              setPreviewUrl(`${process.env.REACT_APP_BASE}/getImage/${filtered[0].FileID}`)
              setShowImage(true);
          }else{
              const data = {
                  topic:Topic
              }
  
              await axios.post(
                  `${process.env.REACT_APP_BASE}/GetFile/${sessionStorage.getItem('Order_ID')}`,
                  data,
                  { responseType: 'blob' }
                  ).then(response => {
                  if (response.status === 200) {
                      
                      const blob = response.data;
                      const blobUrl = URL.createObjectURL(blob);

                      const filtered = AllFileList.filter(item => item.Topic.trim() === Topic);

                      setSubFileList(filtered);
                      setShowFileID(filtered[0].FileID)
                      console.log(filtered)
                  
                      setPreviewUrl(blobUrl);    
                      setShowFile(true);       
                      setisActive(false);      
                  }
                  }).catch(err => {
                  console.error("Error while fetching file:", err);
                  setisActive(false);
                  });
          }
          }else{
              setisActive(true)
              const data = {
                  topic:Topic
              }
              
              await axios.post(
                  `${process.env.REACT_APP_BASE}/GetFile/${sessionStorage.getItem('Order_ID')}`,
                  data,
                  { responseType: 'blob' }
              ).then(response => {
                  if (response.status === 200) {
                      
                  const blob = response.data;
                  const blobUrl = URL.createObjectURL(blob);
              
                  const filtered = AllFileList.filter(item => item.Topic.trim() === Topic);

                  setSubFileList(filtered);
                  setShowFileID(filtered[0].FileID)
                  console.log(filtered)

                  setPreviewUrl(blobUrl);   
                  setShowFile(true);         
                  setisActive(false);      
                  }
              }).catch(err => {
                  console.error("Error while fetching file:", err);
                  setisActive(false);
              });
              
          }
    }

    async function ViewTool(id:any){
        const data = {
            topic:Topic,
        }
        await axios.post(
            `${process.env.REACT_APP_BASE}/GetFileForMultiplePDFAccept/${sessionStorage.getItem('Order_ID')}/${id}`,
            data,
            { responseType: 'blob' }
          ).then(response =>{
            if (response.status === 200) {
                setFileType(response.headers['content-type'])
                console.log('Content-Type:', response.headers['content-type']);

                const blob = response.data; 
                const blobUrl = URL.createObjectURL(blob);
                let URLData = `${process.env.REACT_APP_BASE}/getEachFile/`
                setPreviewUrl(blobUrl); 
            }
          }).catch(err => {
            console.error("Error while fetching file:", err);
            setisActive(false);
          });
        if(Topic=='เครื่องมือหรือแบบสอบถาม (ถ้ามี)'){
            
           
        }else if (Topic=='เอกสารสัญญาการให้ทุนวิจัย (ถ้ามี)'){
            const data = {
                topic:'เครื่องมือหรือแบบสอบถาม (ถ้ามี)',
            }

        }
    
        }

    function DeleteTool(id: any) {
        setShowDeletion(false);
        axios
            .delete(`${process.env.REACT_APP_BASE}/DeleteTool/${id}`)
            .then((response) => {
            if (response.status === 200) {
                setShowDeletion(false);
                setShowFileID(undefined)
                setShowFile(false);
                axios
                .get(`${process.env.REACT_APP_BASE}/getFileList/${sessionStorage.getItem('Order_ID')}`)
                .then((res) => {
                    if (res.status === 200 && Array.isArray(res.data)) {
                    const uploadedFiles = res.data;
        
                    // Update status in FileAttachment
                    const updatedList = FileAttachment.map((item) => {
                        const isUploaded = uploadedFiles.some((file: { Topic: string }) =>
                        file.Topic?.trim() === item.AttachmentType?.trim()
                        );
                        return {
                        ...item,
                        Status: isUploaded ? 'แนบแล้ว' : 'ยังไม่แนบ',
                        };
                    });
        
                    setAllFileList(uploadedFiles);
                    setFileAttachment(updatedList);
        
                    setShowMultipleFiles(false);
                    setPreviewUrl(null);
                    }else if(res.status === 200){
                    setShowMultipleFiles(false);
                    setPreviewUrl(null);
                    setShowDeletion(false)
                    setShowFileID(undefined)
                    setShowFile(false);
                    }
                })
                .catch((err) => {
                    console.error('Error fetching file list after deletion:', err);
                });
            }
            })
            .catch((err) => {
            console.error('Error deleting file:', err);
            });
        }

    async function getData(){
        await axios
        .get(`${process.env.REACT_APP_BASE}/getFileList/${sessionStorage.getItem('Order_ID')}`)
        .then((res) => {
          if (res.status === 200 && res.data) {
            const uploadedFiles = res.data; // Array of { Topic: string }
      
            const updatedList = FileAttachment.map((item) => {
              const isUploaded = uploadedFiles.some(
                (file: { Topic: string }) => file.Topic === item.AttachmentType
              );
              return {
                ...item,
                Status: isUploaded ? 'แนบแล้ว' : 'ยังไม่แนบ',
              };
            });
      
            setAllFileList(uploadedFiles);
            setFileAttachment(updatedList);
      
            const requiredTopics = [
              'เค้าโครงวิจัย 3 บท',
              'หลักฐานการผ่านการอบรมจริยธรรมการวิจัยในมนุษย์',
              'หลักฐานการชำระเงินค่าธรรมเนียมในการพิจารณาจริยธรรมการวิจัยในมนุษย์',
            ];
      
            const allRequiredUploaded = requiredTopics.every((requiredTopic) =>
              uploadedFiles.some((file: { Topic: string }) => file.Topic.trim() === requiredTopic)
            );

            if(uploadedFiles.filter
                ((item:{ Topic: string })=>item.Topic.trim()=='เค้าโครงวิจัย 3 บท').length!=0){
                setPart3OutlineStatus(false)
            }
            if(uploadedFiles.filter((item:{ Topic: string })=>item.Topic.trim()=='หลักฐานการผ่านการอบรมจริยธรรมการวิจัยในมนุษย์').length!=0){
                setPart3CourseStatus(false)
            }
            if(uploadedFiles.filter((item:{ Topic: string })=>item.Topic.trim()=='หลักฐานการชำระเงินค่าธรรมเนียมในการพิจารณาจริยธรรมการวิจัยในมนุษย์').length!=0){
                setPart3RecieptStatus(false)
            }
      
            if (allRequiredUploaded) {
                console.log('part3')
                setPart3Status(false)
            }
          }
        });
    }

    useEffect(() => {
        getData();
    }, []);

    
    return(<>
        <h1 style={{fontSize:40,marginBottom:0}}>แบบฟอร์มการยื่นคำขอพิจารณาจริยธรรมวิจัยในมนุษย์</h1>
        <h2 style={{fontSize:30,marginTop:0,marginBottom:10}}>แนบเอกสารหลักฐานเพิ่มเติม</h2>
        <hr/>
        <Table
        rowClassName={() => 'centered-row'}
        columns={[{
                title:'ลำดับ',
                width:'2vw',
                dataIndex:'id',
                
            },{
                title:'ประเภทเอกสาร',
                dataIndex:'AttachmentType',
                render:(__, record)=> <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center', 
                        height: '100%', 
                    }}
                >

                    {record.Status === 'แนบแล้ว' ? (
                        <a onClick={() => viewFile(record.AttachmentType)}>{record.AttachmentType}</a>
                    ) : (
                        <p style={{marginTop:0,marginBottom:0}}>{record.AttachmentType}</p>
                    )}

                    {(record.AttachmentType === 'เอกสารรับรองการสอบผ่านโครงร่างวิทยานิพนธ์ ภาคนิพนธ์ หรือการศึกษาค้นคว้าอิสระ'
                    ) && (<>
                             <><p style={{ margin: 0,color:'gray' }}>กรุณาใช้ฟอร์ม <a target="_blank" rel="noopener noreferrer" 
                                href="https://docs.google.com/document/d/1gOrEgTOi9TueuuwKwIJzIBlEWCEC1RaZ/edit?usp=drive_link&ouid=108248642863164545698&rtpof=true&sd=true">
                                     มว.จ.004 เอกสารรับรองการสอบผ่านโครงร่างวิทยานิพนธ์,ภาคนิพนธ์,การศึกษาค้นคว้าอิสระ</a> ในการยื่น </p></>
                        </>
                    )}
                       {(
                        record.AttachmentType === 'เค้าโครงวิจัย 3 บท'
                       
                    ) && (
                        <p style={{ margin: 0,color:'red' }}>( **ต้องอัพโหลด** อัพได้เพียงไฟล์สกุล PDF จำนวน 1 ไฟล์)</p>
                    )}
                    {(
                     
                        record.AttachmentType === 'หลักฐานการชำระเงินค่าธรรมเนียมในการพิจารณาจริยธรรมการวิจัยในมนุษย์'
                    ) && (
                        <p style={{ margin: 0,color:'red' }}>( **ต้องอัพโหลด** อัพได้เพียงไฟล์สกุล PDF จำนวน 1 ไฟล์ และต้องใบเสร็จชำระเงินที่ออกโดยมหาวิทยาลัยวงษ์ชลิตกุลเท่านั้น)</p>
                    )}
                    {record.AttachmentType === 'เครื่องมือหรือแบบสอบถาม (ถ้ามี)' && (
                        <p style={{ margin: 0,color:'gray' }}>( อัพได้เพียงไฟล์สกุล PDF เท่านั้น / ไม่จำกัดจำนวนไฟล์ )</p>
                    )}
                    {(record.AttachmentType === 'หนังสือรับรองการประเมินคุณภาพเครื่องมือวิจัย(ถ้ามี)'
                    ||record.AttachmentType === 'เอกสารแสดงความยินยอมเข้าร่วมโครงการวิจัยสำหรับอาสาสมัครทั่วไป (ถ้าเกี่ยวข้อง)'
                    ||record.AttachmentType === 'เอกสารแสดงความยินยอมเข้าร่วมโครงการวิจัยสำหรับอาสาสมัครเด็ก 7-18 ปี (ถ้าเกี่ยวข้อง)'
                    ) && (<>
                            {record.AttachmentType === 'เอกสารแสดงความยินยอมเข้าร่วมโครงการวิจัยสำหรับอาสาสมัครเด็ก 7-18 ปี (ถ้าเกี่ยวข้อง)'&&
                                <><p style={{ margin: 0,color:'gray' }}>กรุณาใช้ฟอร์ม <a target="_blank" rel="noopener noreferrer"
                                 href="https://docs.google.com/document/d/1AEY_efCz4hlSHYZiEanIE0F0_kLIqtvJ/edit?usp=drive_link&ouid=108248642863164545698&rtpof=true&sd=true">
                                    มว.จ.003-1 เอกสารแสดงความยินยอมเข้าร่วมโครงการวิจัยสำหรับอาสาสมัครเด็กอายุ 7-18 ปี</a> ในการยื่น </p></>}
                            {record.AttachmentType === 'เอกสารแสดงความยินยอมเข้าร่วมโครงการวิจัยสำหรับอาสาสมัครทั่วไป (ถ้าเกี่ยวข้อง)'&&
                                <><p style={{ margin: 0,color:'gray' }}>กรุณาใช้ฟอร์ม <a target="_blank" rel="noopener noreferrer" 
                                href="https://docs.google.com/document/d/1CdqP07e4QP_cL_QPbxDx0lQDO9pwHAxG/edit?usp=drive_link&ouid=108248642863164545698&rtpof=true&sd=true">
                                    มว.จ.003 เอกสารแสดงความยินยอมเข้าร่วมโครงการวิจัย</a> ในการยื่น </p></>}
                            <p style={{ margin: 0,color:'gray' }}>( อัพได้เพียงไฟล์สกุล PDF เท่านั้น / จำกัด 1 ไฟล์ )</p>
                        </>
                    )}
                    {record.AttachmentType === 'เอกสารสัญญาการให้ทุนวิจัย (ถ้ามี)' && (
                        <p style={{ margin: 0,color:'gray' }}>( อัพได้เพียงไฟล์สกุล PDF,JPG,PNG เท่านั้น / ไม่จำกัดจำนวนไฟล์ )</p>
                    )}
                    {record.AttachmentType === 'หลักฐานการผ่านการอบรมจริยธรรมการวิจัยในมนุษย์' && (
                        <>
                            <p style={{ margin: 0,color:'red' }}>( **ต้องอัพโหลด** อัพได้เพียงไฟล์สกุล PDF,JPGJPG,PNG เท่านั้น / จำกัด 1 ไฟล์ )</p>
                            <p style={{ margin: 0,color:'red' }}>( ในกรณีที่มีผู้ร่วมวิจัยมากกว่า 1 ท่าน ให้ท่านรวมไฟล์ทั้งหมดเป็นไฟล์เดียว )</p>
                        </>)}
                    {(record.AttachmentType === 'เอกสารแสดงความยินยอมสำหรับอาสาสมัครกลุ่มเปราะบาง (ถ้าเกี่ยวข้อง)'
                    ||record.AttachmentType === 'เอกสารรับรองการสอบผ่านโครงร่างวิทยานิพนธ์ ภาคนิพนธ์ หรือการศึกษาค้นคว้าอิสระ'
                    ) && (<>
                            {record.AttachmentType === 'เอกสารแสดงความยินยอมสำหรับอาสาสมัครกลุ่มเปราะบาง (ถ้าเกี่ยวข้อง)'&&
                                <><p style={{ margin: 0,color:'gray' }}>กรุณาใช้ฟอร์ม <a target="_blank" rel="noopener noreferrer" 
                                href="https://docs.google.com/document/d/13KzYKP-mxXYsvmzbc0Q4V_-I1RtpRTA3/edit?usp=drive_link&ouid=108248642863164545698&rtpof=true&sd=true">
                                     มว.จ.003-2 เอกสารแสดงความยินยอมเข้าร่วมโครงการวิจัยสำหรับอาสาสมัครกลุ่มเปราะบาง</a> ในการยื่น </p></>}
                            <p style={{ margin: 0,color:'gray' }}>( อัพได้เพียงไฟล์สกุล PDF เท่านั้น / จำกัด 1 ไฟล์ )</p>
                        </>
                    )}
                    {record.AttachmentType === 'หลักฐานการรับรองคำพิจารณาจริยธรรมจากที่ปรึกษา (สำหรับนักศึกษา)' && (
                        <>
                          <p style={{ margin: 0,color:'gray' }}>กรุณาใช้ฟอร์ม <a onClick={() => {
                              window.open(`${process.env.REACT_APP_BASE}/generate-part1/${sessionStorage.getItem('Order_ID')}/${sessionStorage.getItem('user')}`);
                              }}>มว.จ. 001 คำขอรับรองการพิจารณาจริยธรรมการวิจัยในมนุษย์</a>ในการยื่น </p>
                          <p style={{ margin: 0,color:'gray' }}>( กรุณากรอกฟอร์ม มว.จ. 001 คำขอรับรองการพิจารณาจริยธรรมการวิจัยในมนุษย์ ให้แล้วเสร็จก่อนโหลดฟอร์ม )</p>
                          <p style={{ margin: 0,color:'gray' }}>( อัพได้เพียงไฟล์สกุล PDF เท่านั้น / ไม่จำกัดจำนวนไฟล์ )</p>
                        </>
                    )}
              </div>
            },{
                title:'สถานะเอกสาร',
                dataIndex:'Status'
            },{
                title:'อัพโหลด',
                dataIndex:'Upload',
                render: (_, record) => {
                    // Define allowed types dynamically
                    let accept = '.pdf'; // default
                  
                    if (record.AttachmentType === 'เอกสารสัญญาการให้ทุนวิจัย (ถ้ามี)' ||
                        record.AttachmentType === 'หลักฐานการผ่านการอบรมจริยธรรมการวิจัยในมนุษย์') {
                      accept = '.pdf,.jpg,.jpeg,.png';
                    }
                  
                    // Optional: stricter validation (prevent renaming trick)
                    const beforeUpload = (file: RcFile) => {
                      const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg'];
                      const isAllowed = allowedTypes.includes(file.type);
                      if (!isAllowed) {
                        message.error('ไฟล์ต้องเป็น PDF, PNG หรือ JPEG เท่านั้น');
                        return Upload.LIST_IGNORE;
                      }
                      return true;
                    };
                  
                    return (
                      <Upload
                        name="file"
                        accept={accept}
                        beforeUpload={beforeUpload}
                        data={(file) => ({
                          topic: record.AttachmentType,
                          filename: file.name,
                        })}
                        {...props}
                      >
                        <Button icon={<UploadOutlined />}>
                          อัพโหลดไฟล์
                        </Button>
                      </Upload>
                    );
                  }
            }
        ]}
        pagination={false}
        dataSource={FileAttachment}/>
        <br/>
        <Flex justify='center'><Button disabled={Part3Status} onClick={()=>
          navigate(`/VU_HREC/ProjectInfo`)
        }>ยืนยันเอกสารและดูสรุปข้อมูล</Button></Flex>

        <Modal
            width={'70vw'}
            open={ShowFile}
            onCancel={()=>{
                setShowFile(false);
                setPreviewUrl(null);
            }}
            footer={<></>}
            >
                <Flex justify='space-between'>
                    <h2>ข้อมูลเอกสาร</h2>
                </Flex>
                <hr/>
                <Flex justify='center'>
                    <h2><Button danger onClick={()=>setShowDeletion(true)} type='primary'>ลบไฟล์</Button></h2>
                </Flex>
                {<>{previewUrl ? (
                    <iframe
                        src={previewUrl}
                        width="100%"
                        height="600px"
                        title="PDF Viewer"
                    />
                    ) : (
                    <p>Loading...</p>
                    )}</>}
                <Modal 
                open={ShowDeletion}
                footer={<></>}
                centered
                onCancel={()=>{
                    setShowDeletion(false);
                }}
                >
                    <p>ต้องการลบเอกสารดังกล่าวใช่หรือไม่</p>
                    <Flex justify='flex-end'>
                        <Button danger onClick={()=>DeleteTool(ShowFileID)} type='primary' style={{marginRight:'20px'}}>ลบไฟล์</Button>
                        <Button type='primary' onClick={()=>setShowDeletion(false)}>ยกเลิก</Button>
                    </Flex>
                </Modal>
        </Modal>
        <Modal
            width={'70vw'}
            open={ShowImage}
            onCancel={()=>{
                setShowImage(false);
                setPreviewUrl(null);
            }}
            footer={<></>}
            >
                <h2>ข้อมูลเอกสาร</h2>
                <hr/>
                {previewUrl&&
                <Flex justify='center'>
                    <img src={previewUrl}
                    width={'100%'}
                     alt="Uploaded Image" />
                </Flex>}
                <br/>
                <Flex justify='center'>
                    <Button type="primary" icon={<UploadOutlined />} onClick={() => {
                        window.open(previewUrl||'', '_blank');
                        }}>
                        ดาวน์โหลด
                    </Button>&nbsp;</Flex>
            </Modal>
        <Modal
        open={ShowMultipleFiles}
        onCancel={()=>{
            setShowMultipleFiles(false);
            setPreviewUrl(null);}}
        width={'50vw'}
        footer={<></>}
        >
        <h2>ข้อมูลเอกสาร</h2>
        <hr/>
        <List 
            pagination={{
                position: 'bottom',      
                align: 'end',            
                pageSize: 5,             
                showSizeChanger: true,   
                showQuickJumper: true    
              }}
              dataSource={SubFileList}
              renderItem={(item, index) =>(
                <><List.Item
                    actions={[<a onClick={()=>ViewTool(item.FileID)}>ดูไฟล์</a>, <a onClick={()=>DeleteTool(item.FileID)}>ลบ</a>]}>
                    <List.Item.Meta
                        title={<p>{item.FileName}</p>}
                       />
                </List.Item>
                    <br/>
                  
                </>
              )}
            />
            <br/>
            <Flex justify='center'>
              {
                previewUrl&&<>
                    {
                        FileType=='application/pdf'&&
                        <iframe
                            src={previewUrl}
                            width="80%"
                            height="600px"
                            title="PDF Viewer"
                            /> ||
                        <img src={previewUrl} alt="Uploaded Image" />
                    }
                </>
              }
            </Flex>
    </Modal>
    </>)
}